import { breakpoints } from "../common/constant.js";
export const theme = {
    content: [],
    theme: {
        screens: breakpoints,
        transitionTimingFunction: {
            'DEFAULT': 'cubic-bezier(0.4, 0, 0.2, 1)',
            'in': 'cubic-bezier(0.4, 0, 1, 1)',
            'out': 'cubic-bezier(0, 0, 0.2, 1)',
            'in-out': 'cubic-bezier(0.4, 0, 0.2, 1)',
            'bounce-in': 'cubic-bezier(0.345, 0.115, 0.135, 1.42)'
        },
        container: {
            padding: {
                'DEFAULT': '1.25rem',
                'sm': '1.5rem',
                'lg': '2rem',
                'xl': '4.375rem',
                '2xl': '4.375rem'
            },
            center: true
        },
        fontSize: {
            'xs': [
                '0.8125rem',
                '1.0625rem'
            ],
            'sm': [
                '0.875rem',
                '1.5rem'
            ],
            'base': [
                '1rem',
                '1.75rem'
            ],
            'lg': [
                '1.25rem',
                '1.875rem'
            ],
            'xl': [
                '1.375rem',
                '1.875rem'
            ],
            '2xl': [
                '1.5rem',
                '2rem'
            ],
            '3xl': [
                '1.75rem',
                '2.25rem'
            ],
            '4xl': [
                '2.125rem',
                '2.625rem'
            ],
            '5xl': [
                '2.5rem',
                '4rem'
            ],
            '6xl': [
                '3rem',
                '4rem'
            ],
            '7xl': [
                '4.5rem',
                '6rem'
            ]
        },
        fontFamily: {
            sans: [
                'Montserrat',
                'var(--font-montserrat, Montserrat)',
                'ui-sans-serif',
                'system-ui',
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                '"Noto Sans"',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
                '"Noto Color Emoji"'
            ]
        },
        colors: {
            inherit: 'inherit',
            current: 'currentColor',
            transparent: 'transparent',
            black: '#000',
            white: '#fff',
            primary: {
                50: '#ebf4f6',
                100: '#DFEDEF',
                700: '#18808C',
                800: '#01697D',
                DEFAULT: '#18808C'
            },
            secondary: {
                50: '#fffbf5',
                200: '#fed99b',
                DEFAULT: '#fed99b'
            },
            gray: {
                50: '#fafcfc',
                75: '#f4f9fb',
                100: '#edefef',
                200: '#cfd8dc',
                700: '#42484d'
            },
            success: '#45a57c',
            warning: '#DD7936',
            danger: '#ba4534'
        },
        extend: {
            aspectRatio: {
                '4/3': '4 / 3',
                '3/4': '3 / 4'
            },
            spacing: {
                15: '3.75rem',
                25: '6.25rem'
            },
            dropShadow: {
                'header': '0 2px 2px rgba(0, 0, 0, 0.05)'
            },
            keyframes: {
                'collapsible-open': {
                    from: {
                        height: '0'
                    },
                    to: {
                        height: 'var(--radix-collapsible-content-height)'
                    }
                },
                'collapsible-close': {
                    from: {
                        height: 'var(--radix-collapsible-content-height)'
                    },
                    to: {
                        height: '0'
                    }
                }
            },
            animation: {
                'collapsible-open': 'collapsible-open 0.2s ease-in-out',
                'collapsible-close': 'collapsible-close 0.2s ease-in-out'
            },
            width: {
                'grid-1': 'calc( ( 100% - ( 1.25rem * 0 ) ) / 1 )',
                'grid-2': 'calc( ( 100% - ( 1.25rem * 1 ) ) / 2 )',
                'grid-3': 'calc( ( 100% - ( 1.25rem * 2 ) ) / 3 )',
                'grid-4': 'calc( ( 100% - ( 1.25rem * 3 ) ) / 4 )'
            }
        }
    }
};
